import { render, staticRenderFns } from "./ViewAnswerRule.vue?vue&type=template&id=44f850fa&scoped=true"
import script from "./ViewAnswerRule.vue?vue&type=script&lang=js"
export * from "./ViewAnswerRule.vue?vue&type=script&lang=js"
import style0 from "./ViewAnswerRule.vue?vue&type=style&index=0&id=44f850fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f850fa",
  null
  
)

export default component.exports